import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { Table } from "@pentabd/ui";

import { SearchBox, SelectControllerVertical } from "@components";
import { TableColumn } from "./TableColumn";

import { useLanguage } from "@hooks/useLanguage";
import { useBaseData } from "@hooks/useBaseData";

import { TablePagination } from "@helpers/tablePagination";
import {
  getConvertedPositionData,
  getConvertedUnitData,
  getConvertedOfficeAddress,
} from "@helpers/baseDataConvert";

import { BASE_DATA } from "@constants/base-data";
import { useDeceased } from "@hooks/HRM/employees/useDeceaseds";

const { DESIGNATIONS, WINGS, OFFICE } = BASE_DATA;

export const DeceasedListTable = () => {
  const { t } = useTranslation();

  const { language } = useLanguage();

  const { data: positions } = useBaseData(DESIGNATIONS);
  const { data: wings } = useBaseData(WINGS);
  const { data: office } = useBaseData(OFFICE);

  const { control, register, setValue } = useForm();
  const { data: employees, pagination, handleQuery } = useDeceased();
  const { total } = pagination || {};

  return (
    <div className="py-10">
      <Table
        header={{
          title: t("DECEASED_LIST.TABLE.HEADER"),
          badge: {
            label: `${total || 0}`,
            size: "sm",
            type: "primary",
          },
          buttons: [
            <SearchBox
              key="search"
              control={control}
              handleQuery={handleQuery}
            />,
          ],
        }}
        headerExtension={{
          rightComponents: [
            <div className="row promotion-candidate-list">
              <SelectControllerVertical
                control={control}
                label="PROMOTION_CANDIDATES.TABLE.FORM.OFFICE"
                name="officeId"
                options={getConvertedOfficeAddress(office, language)}
                register={register}
                setValue={setValue}
                isSearchable
                selectAction={(e) => {
                  handleQuery("officeId", e);
                }}
                portal
                cols={4}
                withoutLabel
              />

              <SelectControllerVertical
                control={control}
                label="PROMOTION_CANDIDATES.TABLE.FORM.DESIGNATION"
                name="positionId"
                options={getConvertedPositionData(positions, language)}
                register={register}
                setValue={setValue}
                isSearchable
                selectAction={(e) => {
                  handleQuery("positionId", e);
                }}
                portal
                cols={4}
                withoutLabel
              />

              <SelectControllerVertical
                control={control}
                label="PROMOTION_CANDIDATES.TABLE.FORM.UNIT"
                name="unitId"
                options={getConvertedUnitData(
                  wings.filter((item: any) => item?.name !== "ACC"),
                  language,
                )}
                register={register}
                setValue={setValue}
                isSearchable
                selectAction={(e) => {
                  handleQuery("unitId", e);
                }}
                portal
                cols={4}
                withoutLabel
              />
            </div>,
          ],
        }}
        columns={TableColumn(t) as any}
        rows={employees || []}
        pagination={TablePagination(pagination, handleQuery)}
      />
    </div>
  );
};
